import { createFeatureSelector} from '@ngrx/store';

import { AppState } from '@aes/core/core.state';
import { ChangePasswordState } from './change-password.models';

export const FEATURE_NAME = 'changePasswordState';

export interface ChangePasswordAppState extends AppState {
    changePasswordState: ChangePasswordState;
}

export const selectChangePasswordState = createFeatureSelector<ChangePasswordAppState, ChangePasswordState>(FEATURE_NAME);
